import React from 'react'
import styles from './Gallery.scss'
import { wrapInt } from 'lib/utils'
import * as urlHelpers from 'lib/urlHelpers'
import { Range } from 'immutable'
import preloadImg from 'lib/preloadImg'
import _ from 'lodash'
import { injectIntl, defineMessages } from 'react-intl'

/*
height rules

CSS
- try to be 600px tall
- if the viewport is smaller than 750px tall, height is 80% of the viewport height

JS
- if the min aspect ratio (w/h) is > 1 (i.e. there are no portrait photos),
  set the height of the gallery to be clientWidth/aspect (use the CSS padding hack)
*/

const MAX_HEIGHT = 675 // should match CSS value

const galleryMessages = defineMessages({
  advance: {
    id: 'galleryMessages.advance',
    defaultMessage: 'click to advance'
  }
})

export class _Gallery extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selected: 0,
      width: null
    }
    this._throttledResize = _.throttle(this.setWidth, 300)
  }

  componentDidMount () {
    this.preload()
    window.addEventListener('resize', this._throttledResize)
    this.setWidth()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this._throttledResize)
  }

  componentDidUpdate () {
    this.preload()
  }

  onClickThumb = (selected) => {
    this.setState({ selected })
  }

  onClick = (e) => {
    if (this.props.onClick) {
      this.props.onClick(this.state.selected)
    } else {
      this.advance()
    }
  }

  advance = () => {
    const selected = (this.state.selected + 1) % this.props.imageIds.length
    this.setState({ selected })
  }

  prev = () => {
    const selected = this.state.selected > 0
      ? this.state.selected - 1
      : this.props.imageIds.length - 1
    this.setState({ selected })
  }

  preload = () => {
    const { selected } = this.state
    const { imageIds } = this.props
    const toPreload = Range(selected - 5, selected + 5)
      .map((i) => wrapInt(i, imageIds.length))
      .map(i => imageIds[i])

    toPreload
      .forEach(id => preloadImg(urlHelpers.photoLarge(id)))
  }

  setWidth = () => {
    if (!this._ref) {
      return
    }
    const width = this._ref.clientWidth
    if (Number.isFinite(width) && this.state.width !== width) {
      this.setState({ width })
    }
  }

  setRef = (ref) => {
    this._ref = ref
  }

  onKeyDown = (e) => {
    const ARROW_LEFT = 37
    const ARROW_RIGHT = 39
    switch (e.keyCode) {
      case ARROW_LEFT:
        this.prev()
        break
      case ARROW_RIGHT:
        this.advance()
        break
      default:
        break
    }
  }

  getHeight = () => {
    const { minAspect } = this.props
    const { width } = this.state
    if (!width || !minAspect) {
      return MAX_HEIGHT
    }
    return Math.min(Math.round(width / minAspect), MAX_HEIGHT)
  }

  render () {
    const { imageIds, focusable, intl } = this.props
    const { selected } = this.state
    const height = this.getHeight()
    return (
      <div ref={this.setRef} className={styles.Gallery} tabIndex={focusable && '0'} onKeyDown={this.onKeyDown}>
        <div className={styles.mainPhoto} style={{ height }}>
          <img src={urlHelpers.photoLarge(imageIds[selected])} onClick={this.advance} title={intl.formatMessage(galleryMessages.advance)} />
        </div>
        <div className={styles.filmstrip}>
          {imageIds.map((id, index) => <img key={id}
            src={`/photos/milli/${id}.jpg`}
            className={id === imageIds[selected] && styles.selected}
            onClick={() => this.onClickThumb(index)} />)}
        </div>
      </div>
    )
  }
}

export const Gallery = injectIntl(_Gallery)
